import React from 'react';
import PropTypes from 'prop-types';
import { DataTable } from '@contently/toolkit';
import TitleCell from './TitleCell';
import RegularCell from './RegularCell';
import ContentSpendCell from './ContentSpendCell';
import TrafficValueCell from './TrafficValueCell';
import PillarCell from './PillarCell';

function TableWrapper({ tableInfo, trafficValAvg }) {
  const defaultColumns = [
    {
      Header: 'Title',
      accessor: 'title',
      minWidth: 350,
      Cell: TitleCell
    },
    {
      Header: 'Pillar',
      accessor: 'content_pillar',
      Cell: PillarCell
    },
    {
      Header: 'Spend',
      accessor: 'content_spend',
      Cell: ContentSpendCell
    },
    {
      Header: 'SEO Traffic',
      accessor: 'traffic',
      Cell: RegularCell
    },
    {
      Header: 'SEO Traffic Value',
      accessor: 'traffic_value',
      Cell: props => <TrafficValueCell data={props} trafficValAvg={trafficValAvg} />
    }
  ];

  return (
    <DataTable.Table
      data={tableInfo}
      columns={defaultColumns}
      pageSize={10}
      showTotal={false}
      defaultSortBy={[{ id: 'traffic_value', desc: true }]}
      errorMessage="No data is available yet - please add published URLs in order to see the content value of your stories next month."
    />
  );
}

export default TableWrapper;

TableWrapper.propTypes = {
  tableInfo: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      pillar: PropTypes.string,
      totalContentDebit: PropTypes.string,
      totalOrganicSearchTraffic: PropTypes.number,
      totalOrganicSearchTrafficValue: PropTypes.string
    })
  ).isRequired,
  trafficValAvg: PropTypes.number.isRequired
};



// WEBPACK FOOTER //
// ./app/javascript/app/components/story_level_value/table_wrapper.jsx